// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-845756a0]:export{primaryColor:#004e87}footer a[data-v-845756a0]{color:#e4e4e4;text-decoration:none}footer a[data-v-845756a0]:focus,footer a[data-v-845756a0]:hover{color:#fff}footer .footer-links>li[data-v-845756a0]:not(:last-child):after{content:\"|\";display:inline-block;margin:0 .5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
